<app-top-panel-menu></app-top-panel-menu>
<app-toolbox></app-toolbox>
<div class="dashboard-content__outlet">
    <div class="v-contener__outlet">
        <router-outlet></router-outlet>
    </div>
</div>
<ng-container [cdkPortalOutlet]="portal|async"></ng-container>

